import { Tooltip, type TooltipProps } from 'primereact/tooltip';
import { type ReactNode, useContext } from 'react';

import { ButtonContext } from './ButtonContext';

interface CustomButtonTooltipProps extends TooltipProps {
  readonly children: ReactNode;
}

const CustomButtonTooltip = ({ children, ...props }: CustomButtonTooltipProps) => {
  const id = useContext(ButtonContext);
  return (
    <Tooltip {...props} target={`[id='${id}']`} showOnDisabled>
      {children}
    </Tooltip>
  );
};

export default CustomButtonTooltip;
